import { APP_UPDATE_MANIFEST_URL, getCurrentAppVersion, type CurrentAppVersion } from './appVersion';

export interface AppUpdateInfo {
  versionCode: number;
  versionName: string;
  apkUrl: string;
  downloadPageUrl?: string;
  qrPageUrl?: string;
  forceUpdate?: boolean;
  releaseNotes?: string[];
}

export function isNativeAndroidApp(): boolean { return false; }

async function fetchLatestManifest(url: string): Promise<AppUpdateInfo> {
  const response = await fetch(url, {
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return (await response.json()) as AppUpdateInfo;
}

export async function getLatestAppUpdateInfo(): Promise<AppUpdateInfo> {
  return fetchLatestManifest(`${APP_UPDATE_MANIFEST_URL}?t=${Date.now()}`);
}

async function openExternalUrl(url: string): Promise<void> {
  window.open(url, '_blank', 'noopener,noreferrer');
}

export async function checkLatestAppUpdate(): Promise<{ hasUpdate: boolean; latest: AppUpdateInfo | null; current: CurrentAppVersion }> {
  const [latest, current] = await Promise.all([
    getLatestAppUpdateInfo(),
    getCurrentAppVersion(),
  ]);
  return {
    hasUpdate: Number(latest.versionCode) > current.versionCode,
    latest,
    current,
  };
}

export async function openAppDownload(info: AppUpdateInfo): Promise<void> {
  const url = info.downloadPageUrl || info.apkUrl;
  await openExternalUrl(url);
}

export async function openAppDownloadQr(): Promise<void> {
  const info = await getLatestAppUpdateInfo();
  await openExternalUrl(info.qrPageUrl || info.downloadPageUrl || info.apkUrl);
}
